import * as React from "react";
import * as ReactDOM from "react-dom";
import * as _ from "lodash";
import {connect} from "react-redux";
import Button from "../../../../../common/ui/button/Button";
import EnergyMixPanel from "../../../game-ui/energy-mix/EnergyMixPanel";
import {getPowerSourcesData, IPowerSource} from "../../../../../../data/data";
import {countPowerSourcesByType} from "../../../../../../store/reducers/powerSources";
import {startGame} from "../../../../../../store/actions/game";
import {getCarbonOutputPercentage} from '../../../../../../store/reducers/outputs/carbonOutput';

interface Props
{
    power_source_counts: { [id: string]: number };
    carbon_pc: number;
    startGame: () => void;
}

import './SummarySection.scss';
import PowerSource from '../../../power-sources/PowerSource';


class SummarySection extends React.Component<Props, null>
{
    constructor(public props: Props)
    {
        super(props);
    }


    getPowerSoures = () : JSX.Element[] =>
    {
        const {power_source_counts} = this.props;

        const power_sources: IPowerSource[] = getPowerSourcesData();

        return _.map(power_sources, (power_source: IPowerSource, i: number) =>
        {
            return <PowerSource {...power_source} key={i}/>;
        });
    };


    /**
     * render the component
     * @returns {JSX.Element}
     */
    render() : JSX.Element
    {
        const {startGame, carbon_pc} = this.props;

        return <div styleName={'summary-section'}>

            <div styleName={'low-carbon-summary'}>

                <p styleName={'carbon-label'}>low carbon generation</p>

                <p styleName={'carbon-percentage'}>{carbon_pc}%</p>

            </div>

            <div styleName={'power-sources'}>

                {this.getPowerSoures()}

            </div>

        </div>;
    }
}


const mapStateToProps = state =>
{
    return {
        power_source_counts: countPowerSourcesByType(state),
        carbon_pc: getCarbonOutputPercentage(state),
    }
};


const mapDispatchToProps = dispatch =>
{
    return {
        startGame: () => dispatch(startGame()),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(SummarySection);



// WEBPACK FOOTER //
// ./src/ts/app/screens/game/modals/game-over/summary/SummarySection.tsx